import React from 'react';
import {
  List,
  Datagrid,
  TextField,
  TextInput,
  SimpleForm,
  Create,
  ReferenceField,
  ReferenceInput,
  SelectInput,
  DisabledInput,
  Edit,
  Show,
  SimpleShowLayout,
  translate as t,
} from 'admin-on-rest';

import {
  FlatButton,
  CardActions,
} from 'material-ui';

import queryString from 'query-string';
import { Link } from 'react-router-dom';

import SlugLink from '../components/button/SlugLink';
import PageReferenceFilter from '../components/PageReferenceFilter';
import '../styles/global.css';
import RichTextInput from '../components/inputs/RichTextInput';
import RichTextField from '../components/fields/RichTextField';
import EditButton from '../components/button/EditButton';
import lStorage from '../utils/localStorage';
import Delete from '../components/Overrides/mui/delete/Delete';

export const PageList = (props) => (
  <List {...props}>
    <Datagrid>
      <TextField source="title" />
      <ReferenceField label="Book" source="book" reference="books">
        <TextField source="title" />
      </ReferenceField>
      <EditButton {...props} />
    </Datagrid>
  </List>
);

const cardActionStyle = {
  zIndex: 2,
  display: 'inline-block',
  float: 'right',
};

const PageTitle = ({ record }) => (
  <span>{record ? `${record.title}` : ''}</span>
);


export const PagesDelete = (props) => (
  <Delete {...props} redirect={lStorage.string.load('lastParent')} /> // the parent is chapter or book
);

const PageActions = () => (
  <CardActions style={cardActionStyle}>
  </CardActions>
);

export const PageCreate = t((props) => {
  const { bookId, bookName, chapterId, chapterName } = queryString.parse(props.location.search);
  const values = queryString.parse(props.location.search);
  props.location.state ? lStorage.string.save('lastParent', props.location.state.prevPath) : lStorage.string.save('lastParent', '/books'); // eslint-disable-line
  return (
    <Create {...props} actions={<PageActions />} title={props.translate('create.item', { item: props.translate('academy.page') })}>
      <SimpleForm defaultValue={values} redirect={lStorage.string.load('lastParent')}>
        <Link to="/books">
          <FlatButton primary>{props.translate('home')}</FlatButton>
        </Link>
        <Link to={`/books/${bookId}?bookId=${bookId}&bookName=${bookName}&chapterId=${chapterId}&chapterName=${chapterName}`}>
          <FlatButton primary>{bookName}</FlatButton>
        </Link>
        <Link to={`/chapters/${chapterId}?bookId=${bookId}&bookName=${bookName}&chapterId=${chapterId}&chapterName=${chapterName}`}>
          <FlatButton primary>{chapterName}</FlatButton>
        </Link>

        <ReferenceInput label={props.translate('academy.book')} source="bookId" reference="books" allowEmpty>
          <SelectInput defaultValue={values.bookName} optionText="title" />
        </ReferenceInput>
        <PageReferenceFilter source="chapterId" label={props.translate('academy.chapter')} addField />

        <TextInput source="title" label={props.translate('academy.pageTitle')} />
        <RichTextInput source="body" label={props.translate('textBody')} />
        <RichTextField source="body" />
      </SimpleForm>
    </Create>
  );
});

export const PageEdit = t((props) => {
  props.location.state ? lStorage.string.save('lastParent', props.location.state.prevPath) : lStorage.string.save('lastParent', '/books'); // eslint-disable-line
  return (
    <Edit title={<PageTitle />} {...props}>
      <SimpleForm redirect="edit">
        <Link to="/books">
          <FlatButton primary>{props.translate('home')}</FlatButton>
        </Link>

        <SlugLink id="book._id" title="book.title" slug="books" />
        <SlugLink id="chapter._id" title="chapter.title" slug="chapters" />

        <DisabledInput label={props.translate('academy.book')} source="book.title" />
        <DisabledInput label={props.translate('academy.chapter')} source="chapter.title" />

        <TextInput source="title" label={props.translate('academy.page')} />
        <RichTextInput source="body" label={props.translate('textBody')} />
        <RichTextField source="body" />
      </SimpleForm>
    </Edit>
  );
});

export const PageShow = (props) => (
  <Show {...props}>
    <SimpleShowLayout>
      <TextField source="title" />
      <TextField source="body" />
    </SimpleShowLayout>
  </Show>
);
